import { render, staticRenderFns } from "./LocationFooter.vue?vue&type=template&id=43c8cc53"
import script from "./LocationFooter.vue?vue&type=script&lang=js"
export * from "./LocationFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports